import colors from '@/styles/colors'
import { Padding } from '@mui/icons-material'
import { Box, Button, IconButton, Slider } from '@mui/material'
import { styled } from '@mui/material/styles'

export const Header = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100vw',
  height: '69px',
  display: 'flex',
  alignItems: 'center',
  padding: '0 20px',
  backgroundColor: 'white',
  boxSizing: 'border-box',
  boxShadow: '0 1px 2px rgba(0,0,0,.1)',
  zIndex: 10,
  [theme.breakpoints.down('md')]: {
    padding: '0 0 0 10px',
  },
  '& .logo': {
    width: 136,
    height: 30,
    [theme.breakpoints.down('sm')]: {
      width: 30,
    },
  },
  '& .avatar': {
    margin: '0 15px',
    [theme.breakpoints.down('sm')]: {
      margin: 0,
    },
  },
}))

export const HeaderTitleSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  [theme.breakpoints.down('sm')]: {
    alignItems: 'flex-end',
  },
}))

export const PatternEditContainer = styled(Box)({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  bottom: 0,
  borderRadius: '0 !important', // Explicitly remove any border-radius
})

export const PatternContainer = styled(Box)({
  flex: 1,
  overflow: 'hidden',
  display: 'flex',
  height: '100%',
  borderRadius: '0 !important', // Explicitly remove any border-radius
  '.gallery-template': {
    cursor: 'pointer',
    '&.active': {
      border: `3px solid ${colors.meshdomBlue}`,
    },
  },
})

export const HelperTextWrapper = styled(Box)({
  position: 'absolute',
  top: 0,
  left: 10,
  height: 40,
  display: 'flex',
  alignItems: 'center',
})

export const ToolBarWrapper = styled(Box)({
  position: 'absolute',
  right: 0,
  left: 0,
  top: 0,
  height: '72px',
  zIndex: 10,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  // backgroundImage: 'linear-gradient(90deg, #00c4cc, #7d2ae8)',
})

export const ToolBarContainer = styled(Box)({
  padding: '13px 20px',
  display: 'flex',
  flexDirection: 'row-reverse',
  height: 'fit-content',
  alignItems: 'center',
  gap: '10px',
  position: 'relative',
  zIndex: 1,
})

export const ToolBarIcon = styled(IconButton)({
  color: 'white',
  backgroundColor: 'rgba(255, 255, 255, 0.08)',
  backdropFilter: 'blur(10px)',
  border: '1px solid rgba(255, 255, 255, 0.12)',
  borderRadius: '12px',
  width: '44px',
  height: '44px',
  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
  transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
  position: 'relative',
  zIndex: 1,
  '& svg': {
    width: '18px',
    height: '18px',
  },
  '&:hover': {
    backgroundColor: 'rgba(99, 102, 241, 0.2)',
    transform: 'translateY(-2px)',
    boxShadow: '0 4px 16px rgba(99, 102, 241, 0.25)',
    borderColor: 'rgba(99, 102, 241, 0.4)',
  },
  '&:active': {
    transform: 'translateY(0) scale(0.95)',
    backgroundColor: 'rgba(99, 102, 241, 0.3)',
  },
  // Glass morphism inner glow
  '&::before': {
    content: '""',
    position: 'absolute',
    top: '1px',
    left: '1px',
    right: '1px',
    bottom: '1px',
    borderRadius: '11px',
    background: 'linear-gradient(135deg, rgba(255,255,255,0.2), rgba(255,255,255,0.05))',
    pointerEvents: 'none',
  },
  // Remove MUI ripple effect for cleaner look
  '& .MuiTouchRipple-root': {
    display: 'none',
  },
})

export const PatternAssetWrapper = styled(Box)({
  position: 'relative',
  '& .content': {
    display: 'flex',
    overflowY: 'auto',
  },
  '& .tab': {
    marginTop: '20px',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'white',
    '& button': {
      border: `1px solid ${colors.meshdomBlue}`,
      borderRadius: 5,
      color: colors.meshdomBlue,
      width: '100%',
      '& svg': {},
      '&.active': {
        color: 'white',
        border: `1px solid ${colors.meshdomBlue}`,
        backgroundColor: colors.meshdomBlue,
      },
      '&.hover': {
        '& svg': {
          color: 'white',
        },
      },
    },
  },
})

export const PatternAssetList = styled(Box)<{ category: string }>(({ category }) => ({
  flex: 1,
  color: 'black',
  display: 'flex',
  flexWrap: 'wrap',
  gridTemplateColumns: `repeat(auto-fill, ${category === 'color' ? 70 : 140}px)`,
  placeContent: 'flex-start center',
  gap: '8px',
  overflowY: 'auto',
  backgroundColor: '#C8C8C8',
  paddingTop: '12px',
  paddingBottom: '12px',
  borderTopRightRadius: '8px',
  borderBottomRightRadius: '8px',
}))

export const PatternAssetButton = styled(Button)({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  padding: '20px',
  gap: '2px',
  '&.active': {
    color: '#2884FF',
  },
})

export const ButtonDivider = styled(Box)({
  width: '21px',
  height: '1px',
  backgroundColor: '#CAD1D9',
})

export const AssetToggleButtonWrapper = styled(Box)({
  position: 'absolute',
  top: 20,
  right: 36,
  width: 40,
  height: 40,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
})

export const AssetToggleButton = styled(IconButton)({
  backgroundColor: colors.grey,
  '&:hover': {
    backgroundColor: colors.lightGrey,
  },
})

export const AssetItem = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  borderRadius: '6px',
  boxSizing: 'border-box',
  border: `2px solid transparent`,
  '&.active': {
    border: `2px solid ${colors.meshdomBlue}`,
  },
  '& img': { borderRadius: '6px' },
})

export const AssetColorItem = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  borderRadius: '5px',
  border: `2px solid transparent`,
  '&.active': {
    border: `2px solid ${colors.themeOrange}`,
  },
  '& img': { margin: '6px', borderRadius: '6px' },
})

export const PatternProgressLoader = styled(Box)({
  position: 'absolute',
  width: '100%',
  height: '100%',
  backgroundColor: '#000000AA',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
})

export const PrintContainer = styled(Box)({
  display: 'flex',
  height: '100%',
  flex: 1,
  width: 'inherit',
  flexDirection: 'column',
})

export const PrintTabButton = styled(Button)({
  height: '30px',
  width: '50%',
  color: '#211E1E',
  borderRadius: 0,
  fontSize: '10px',
  '&.active': {
    color: `${colors.blue}`,
    borderBottom: `2px solid ${colors.blue}`,
  },
})

export const SettingButtonWrapper = styled(Box)(({ theme }) => ({
  position: 'fixed',
  top: 0,
  right: 0,
  height: '69px',
  display: 'flex',
  alignItems: 'center',
  backgroundColor: 'white',
  justifyContent: 'flex-end',
  padding: '0 10px',
  zIndex: 10,
  [theme.breakpoints.down('sm')]: {
    position: 'absolute',
    top: 10,
    right: 10,
    height: '45px',
  },
}))

export const AlbumAndUploads = styled(Box)({
  position: 'absolute',
  left: 0,
  bottom: 0,
  width: 120,
  height: 60,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '& button': {
    borderRadius: 4,
    border: `2px solid transparent`,
    margin: '0 4px',
    '&.selected': {
      border: `2px solid ${colors.meshdomBlue}`,
    },
  },
})

export const StyledSlider = styled(Slider)({
  color: colors.meshdomBlue,
  height: 4,
  '& .MuiSlider-thumb': {
    height: 12,
    width: 12,
    backgroundColor: '#fff',
    border: `2px solid ${colors.meshdomBlue}`,
    '&:hover': {
      boxShadow: '0 0 0 4px rgba(0, 0, 0, 0.16)',
    },
  },
  '& .MuiSlider-rail': {
    opacity: 0.5,
    backgroundColor: '#bfbfbf',
    height: 4,
  },
  '& .MuiSlider-track': {
    border: 'none',
    height: 4,
  },
  '& .MuiSlider-mark': {
    backgroundColor: '#bfbfbf',
    height: 4,
    width: 1,
    '&.MuiSlider-markActive': {
      opacity: 1,
      backgroundColor: 'currentColor',
    },
  },
})

export const PatternPreviewSlider = styled(Slider)(({ theme }) => ({
  color: '#0d1216',
  height: 8,
  '& .MuiSlider-thumb': {
    height: '20px',
    width: '20px',
    backgroundColor: '#0d1216',
    borderRadius: '50%',
    border: '2px solid #ffffff',
    boxShadow: '0 2px 8px rgba(13, 18, 22, 0.2)',
    '&:hover': {
      boxShadow: '0 4px 12px rgba(13, 18, 22, 0.3)',
      // transform: 'scale(1.1)',
      transform: 'translate(-50%, -50%) scale(1.1)',
    },
    '&:active': {
      boxShadow: '0 2px 8px rgba(13, 18, 22, 0.4)',
    },
    '&::before': {
      display: 'none',
    },
  },
  '& .MuiSlider-rail': {
    opacity: 1,
    backgroundColor: '#d1d5db',
    height: 8,
    borderRadius: 4,
  },
  '& .MuiSlider-track': {
    border: 'none',
    height: 8,
    borderRadius: 4,
    backgroundColor: '#0d1216',
  },
  '& .MuiSlider-mark': {
    display: 'none', // Hide marks for cleaner look
  },
  '& .MuiSlider-valueLabel': {
    backgroundColor: '#0d1216',
    color: '#ffffff',
    fontSize: '12px',
    fontWeight: 500,
    borderRadius: '6px',
    '&::before': {
      borderTopColor: '#0d1216',
    },
  },

  [theme.breakpoints.down('md')]: {
    '& .MuiSlider-thumb': {
      height: '18px',
      width: '18px',
      backgroundColor: '#0d1216',
      borderRadius: '50%',
      border: '2px solid #ffffff',
      '&:hover': {
        boxShadow: '0 4px 12px rgba(13, 18, 22, 0.3)',
        // transform: 'scale(1.1)',
        transform: 'translate(-50%, -50%) scale(1.1)',
      },
    },
  },
}))
